import React from "react";

const MediaSvg2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 512 512"
      class=""
    >
      <g>
        <g xmlns="http://www.w3.org/2000/svg">
          <path
            d="m391 210v-60h-150v-41.459l24.271-48.541h65.729v30h105c24.813 0 45-20.187 45-45s-20.187-45-45-45h-105v30h-84.271l-30 60h-120l-35.729 71.459v39.448l-61-30v228.186l61-30v50.907h120v92h90v-92h120v-60h41.511l79.489 39.093v-228.186l-79.489 39.093zm-30-180h75c8.271 0 15 6.729 15 15s-6.729 15-15 15h-75zm-245.729 90h95.729v30h-110.729zm-85.271 230.907v-131.814l31 15.246v101.323zm211 131.093h-30v-62h30zm120-92h-270v-210h270zm30-150h30v90h-30zm60-5.661 31-15.246v131.814l-31-15.246z"
            fill="#fb4a5b"
            data-original="#000000"
            class=""
          />
          <path
            d="m211 266.493 30.845 18.507-30.845 18.507zm-30-52.983v142.99l119.15-71.5z"
            fill="#fb4a5b"
            data-original="#000000"
            class=""
          />
          <path
            d="m271 210h60v30h-60z"
            fill="#fb4a5b"
            data-original="#000000"
            class=""
          />
        </g>
      </g>
    </svg>
  );
};

export default MediaSvg2;
